// extracted by mini-css-extract-plugin
export var divider = "_3e-0";
export var dividerText = "_3e-2";
export var dividerVertical = "_3e-1";